<script setup lang="ts">
/**
 * Pictogramme Yakafa, identique à la favicon : un « y » dont le bras court
 * (menthe) passe devant le long (vert d'eau), comme une coche — « y'a qu'à »,
 * c'est fait. Le carré foncé le garde lisible sur fond clair comme sombre.
 */
</script>

<template>
  <svg viewBox="0 0 64 64" class="h-7 w-7 shrink-0" aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#0e3b35" />
    <path d="M45 17 L25 49" fill="none" stroke="#5dcaa5" stroke-width="7" stroke-linecap="round" />
    <!-- Le bras court repasse devant le long : l'entrelacement de la marque. -->
    <path d="M20 19 L32 37" fill="none" stroke="#a2e8dd" stroke-width="7" stroke-linecap="round" />
  </svg>
</template>
